import { render, staticRenderFns } from "./UnqualifiedView.vue?vue&type=template&id=28fd02f5&"
import script from "./UnqualifiedView.vue?vue&type=script&lang=js&"
export * from "./UnqualifiedView.vue?vue&type=script&lang=js&"
import style0 from "./UnqualifiedView.vue?vue&type=style&index=0&id=28fd02f5&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports